// import { Box, Typography, Button, CircularProgress } from "@mui/material";
// import { useEffect, useRef, useState } from "react";
// import Tiff from "tiff.js";

// /* ---------------- FILE TYPE DETECTOR ---------------- */

// const getFileType = (url) => {
//   if (!url) return "none";
//   const ext = url.split("?")[0].split(".").pop().toLowerCase();

//   if (ext === "pdf") return "pdf";
//   if (["jpg", "jpeg", "png", "webp"].includes(ext)) return "image";
//   if (["tif", "tiff"].includes(ext)) return "tiff";

//   return "unsupported";
// };

// /* ---------------- MAIN COMPONENT ---------------- */

// export default function ViewerPanel({ selectedDoc }) {
//   const fileUrl = selectedDoc?.fileUrl;
//   const fileType = getFileType(fileUrl);

//   const tiffContainerRef = useRef(null);

//   // TIFF-only states
//   const [tiffStatus, setTiffStatus] = useState("idle"); 
//   // idle | loading | success | error
//   const [tiffError, setTiffError] = useState(null);

//   /* ---------- RESET ON FILE CHANGE ---------- */

//   useEffect(() => {
//     setTiffStatus("idle");
//     setTiffError(null);

//     if (tiffContainerRef.current) {
//       tiffContainerRef.current.innerHTML = "";
//     }

//     if (fileType === "tiff" && fileUrl) {
//       loadTiff(fileUrl);
//     }
//   }, [fileUrl, fileType]);

//   /* ---------------- TIFF LOADER ---------------- */

//   const loadTiff = async (url) => {
//     try {
//       setTiffStatus("loading");

//       const response = await fetch(url);
//       if (!response.ok) throw new Error("Failed to fetch TIFF");

//       const buffer = await response.arrayBuffer();
//       const tiff = new Tiff({ buffer });
//       const canvas = tiff.toCanvas();

//       if (!canvas) throw new Error("TIFF render failed");

//       canvas.style.maxWidth = "100%";
//       canvas.style.height = "auto";

//       if (tiffContainerRef.current) {
//         tiffContainerRef.current.appendChild(canvas);
//       }

//       setTiffStatus("success");
//     } catch (err) {
//       console.error(err);
//       setTiffError("TIFF preview not supported");
//       setTiffStatus("error");
//     }
//   };

//   /* ---------------- RENDER ---------------- */

//   if (!fileUrl) {
//     return (
//       <Box flex={1} display="flex" justifyContent="center" alignItems="center">
//         <Typography color="white">
//           Select a document to preview
//         </Typography>
//       </Box>
//     );
//   }

//   return (
//     <Box flex={1} bgcolor="#888" display="flex" justifyContent="center" alignItems="center" p={2}>
      
//       {/* ---------- PDF ---------- */}
//       {fileType === "pdf" && (
//         <iframe
//           src={fileUrl}
//           title="PDF Viewer"
//           style={{ width: "100%", height: "100%", border: "none" }}
//         />
//       )}

//       {/* ---------- IMAGE ---------- */}
//       {fileType === "image" && (
//         <img
//           src={fileUrl}
//           alt="Document Preview"
//           style={{ maxWidth: "100%", maxHeight: "100%", objectFit: "contain" }}
//         />
//       )}

//       {/* ---------- TIFF ---------- */}
//       {fileType === "tiff" && (
//         <>
//           {tiffStatus === "loading" && (
//             <CircularProgress color="inherit" />
//           )}

//           {tiffStatus === "error" && (
//             <Box textAlign="center">
//               <Typography color="white" mb={2}>
//                 {tiffError}
//               </Typography>
//               <Button
//                 variant="contained"
//                 href={fileUrl}
//                 target="_blank"
//                 rel="noreferrer"
//               >
//                 Download File
//               </Button>
//             </Box>
//           )}

//           <Box
//             ref={tiffContainerRef}
//             sx={{ display: tiffStatus === "success" ? "block" : "none" }}
//           />
//         </>
//       )}

//       {/* ---------- UNSUPPORTED ---------- */}
//       {fileType === "unsupported" && (
//         <Box textAlign="center">
//           <Typography color="white" mb={2}>
//             Preview not supported
//           </Typography>
//           <Button
//             variant="contained"
//             href={fileUrl}
//             target="_blank"
//             rel="noreferrer"
//           >
//             Download File
//           </Button>
//         </Box>
//       )}
//     </Box>
//   );
// }

import { useState } from "react";
import { Box } from "@mui/material";
import DocumentPreview from "../../../../components/DocumentPreview";
import ReindexModal from "../../ReIndexModal";
import SplitModal from "../../SplitModal";
import { useSelector } from "react-redux";


export default function ViewerPanel({ selectedDoc }) {
  const [reindexOpen, setReindexOpen] = useState(false);
  const [reindexDoc, setReindexDoc] = useState(null);
  const [splitOpen, setSplitOpen] = useState(false);

  const documentTypes =
    useSelector(
      (state) => state?.documentReducer?.documentTypeData?.data
    ) || [];

  if (!selectedDoc?.filePath) {
    return (
      <Box
        flex={1}
        display="flex"
        justifyContent="center"
        alignItems="center"
      >
        Select a document to preview
      </Box>
    );
  }
  const getPreviewTypeFromUrl = (url) => {
    if (!url) return "";
  
    const ext = url.split("?")[0].split(".").pop().toLowerCase();
  
    if (ext === "pdf") return "application/pdf";
    if (["jpg", "jpeg", "png", "webp"].includes(ext)) return `image/${ext}`;
    if (["tif", "tiff"].includes(ext)) return "image/tiff";
  
    return "";
  };

  const preview = {
    url: selectedDoc?.filePath,
    type: getPreviewTypeFromUrl(selectedDoc?.filePath),
    sourceData: {
      docId: selectedDoc?.docId || null,
      docAbbrevation: selectedDoc?.docAbbrevation || selectedDoc?.docTypeAbbrevation || "",
      docTypeId: selectedDoc?.docTypeId || "",
      docTypeCode: selectedDoc?.docTypeCode || "",
      originalFilename:
        selectedDoc?.originalFilename || selectedDoc?.originalFileName || selectedDoc?.name || ""
    }
  };

  return (
    <Box flex={1}  p={2}>
      <ReindexModal
  open={reindexOpen}
  sourceDoc={{
      locationNumber: Number(selectedDoc?.locationNumber),
      controlNumber: Number(selectedDoc?.control),
      docAbbrevation: reindexDoc?.sourceData?.docAbbrevation || '',
      docTypeId: reindexDoc?.sourceData?.docTypeId || '',
      docTypeCode: reindexDoc?.sourceData?.docTypeCode || '',
      originalFilename: reindexDoc?.sourceData?.originalFilename || '',
      docTypeData: documentTypes
    }}
  onClose={() => {
    setReindexOpen(false);
    setReindexDoc(null);
  }}
  onSave={async () => {
    setReindexOpen(false);
    setReindexDoc(null);
  }}
/>
      <SplitModal
        open={splitOpen}
        sourceDoc={{
          locationNumber: Number(selectedDoc?.locationNumber),
          controlNumber: Number(selectedDoc?.control),
          docId: preview?.sourceData?.docId || null,
          type: preview?.type || "",
          url: preview?.url || "",
          docAbbrevation: preview?.sourceData?.docAbbrevation || "",
          docTypeId: preview?.sourceData?.docTypeId || "",
          docTypeCode: preview?.sourceData?.docTypeCode || "",
          originalFilename: preview?.sourceData?.originalFilename || "",
          docTypeData: documentTypes
        }}
        onClose={() => {
          setSplitOpen(false);
        }}
        onExtract={async (success, docData, originalFilename) => {
          if (success) {
            setSplitOpen(false);
            setReindexOpen(true);
            setReindexDoc({
              preview,
              sourceData: {
                ...(preview?.sourceData || {}),
                ...(docData || {}),
                originalFilename: originalFilename || preview?.sourceData?.originalFilename || ""
              }
            });
          }
        }}
        onDelete={async (success) => {
          if (success) {
            setSplitOpen(false);
          }
        }}
      />
      <DocumentPreview
        preview={preview}
        height={600}
        // showReindex={false} 
        showReindex={true} 
        showSplit={true}
        onReindex={(doc) => {
          setReindexDoc(doc);
          setReindexOpen(true);
        }}
        onSplit={() => {
          setSplitOpen(true);
        }}
        reindexing={reindexOpen ? true : false}
        category="documents"
      />
    </Box>
  );
}
